import Icon from "@avinet/adaptive-ui-core/ui/Icon";
import { t } from "i18next";
import React, { ReactNode, useCallback, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { NgirLogoIcon } from "../../assets/icons/NgirLogoIcon";
import { UserContext } from "../../context/user-context/UserContext";
import { generatePDF } from "../../utils/pdf-generator";
import { Text } from "../text/Text";
import "./PageLayout.scss";

export const PageLayout = ({
  children,
  isResetPassword,
  isCustomersPage,
  isOrderViewPage,
  isLoginPage,
  title,
  pdfTitle,
  handleGoBack,
}: {
  children: ReactNode;
  isResetPassword?: boolean;
  isCustomersPage?: boolean;
  isOrderViewPage?: boolean;
  isLoginPage?: boolean;
  title?: string;
  pdfTitle?: string;
  handleGoBack?: () => void;
}) => {
  const { logoutUser } = useContext(UserContext);

  const navigate = useNavigate();

  const handleNavigateBack = useCallback(() => {
    if (isOrderViewPage) {
      handleGoBack && handleGoBack();
      return;
    }
    navigate(-1);
  }, [handleGoBack, isOrderViewPage, navigate]);

  const handleLogout = async (e: React.FormEvent) => {
    e.preventDefault();
    logoutUser();
  };

  const handleLanguageChange = useCallback(() => {
    const i18nextLng = localStorage.getItem("i18nextLng");
    if (i18nextLng === "nb") {
      localStorage.setItem("i18nextLng", "nn");
    } else {
      localStorage.setItem("i18nextLng", "nb");
    }
    window.location.reload();
  }, []);

  return (
    <div className="pagelayout">
      <div className="header-container">
        {isLoginPage ? (
          <></>
        ) : isResetPassword ? (
          <div className="back-arrow-container">
            <button className="btn back" onClick={handleNavigateBack}>
              <Icon name="arrow" flip className="arrow-login" />
            </button>
          </div>
        ) : isCustomersPage ? (
          <div className="ngir-header-container">
            {title && (
              <Text
                className="pagelayout-title"
                text={title}
                size="medium"
                color="dark"
                fontWeight={600}
              />
            )}
            <div className="ngir-logo">
              <NgirLogoIcon />
              <Text text={t("common.title")} size="xxs" color="primary" />
              <button
                className="btn language"
                type="submit"
                onClick={handleLanguageChange}
              >
                {t("common.language")}
              </button>
              <button
                className="btn logout customers"
                type="submit"
                onClick={handleLogout}
              >
                {t("common.logout")}
              </button>
            </div>
          </div>
        ) : (
          <div className="ngir-header-container">
            <button className="btn back" onClick={handleNavigateBack}>
              <Icon name="arrow" flip />
            </button>
            <div className="ngir-logo">
              <NgirLogoIcon />
              <Text text={t("common.title")} size="xxs" color="primary" />
            </div>
            <div className="ngir-header-buttons">
              <button
                className="btn language"
                type="submit"
                onClick={handleLanguageChange}
              >
                {t("common.language")}
              </button>
              <button
                className="btn report"
                type="submit"
                onClick={() =>
                  generatePDF(
                    "content",
                    ["orderTable", "subscriptionTable"],
                    pdfTitle ?? ""
                  )
                }
              >
                {t("pages.customersInfo.generateReport")}
              </button>
              <button
                className="btn logout"
                type="submit"
                onClick={handleLogout}
              >
                {t("common.logout")}
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="content" id="content">
        {children}
      </div>
    </div>
  );
};
